// BE error codes of the AI Assistant settings API → Thai messages.
// BE sends { errorCode: <http status>, errorMessage: "<CODE>[: detail]" }.
const MESSAGES = {
  MCP_SUBSCRIPTION_INACTIVE: "AI Assistant ของคลินิกถูกระงับ กรุณาติดต่อทีม Tantatat",
  MCP_DPA_NOT_ACCEPTED: "กรุณายอมรับข้อตกลงการประมวลผลข้อมูล (DPA) ก่อนเปิดใช้งาน",
  MCP_DPA_VERSION_MISMATCH: "ข้อตกลง DPA มีการปรับปรุง กรุณาโหลดหน้าใหม่แล้วยอมรับอีกครั้ง",
  MCP_ENABLED_REQUIRED: "ข้อมูลไม่ถูกต้อง กรุณาลองใหม่",
  MCP_GROUPS_INVALID: "ต้องมีกลุ่มหัตถการ 1–30 กลุ่ม",
  MCP_GROUP_INVALID: "ข้อมูลกลุ่มหัตถการไม่ถูกต้อง",
  MCP_GROUP_CODE_INVALID: "รหัสกลุ่มต้องเป็น A–Z, 0–9 หรือ _ ยาว 2–30 ตัว และขึ้นต้นด้วยตัวอักษร",
  MCP_GROUP_CODE_DUPLICATE: "รหัสกลุ่มซ้ำกัน",
  MCP_GROUP_NAME_INVALID: "กรุณาระบุชื่อกลุ่ม (ไม่เกิน 100 ตัวอักษร)",
  MCP_GROUP_TREATMENTS_INVALID: "เลือกรายการหัตถการได้ไม่เกิน 1,000 รายการต่อกลุ่ม",
  MCP_GROUP_CATEGORIES_INVALID: "เลือกหมวดหัตถการได้ไม่เกิน 200 หมวดต่อกลุ่ม",
  MCP_SCALING_GROUP_REQUIRED: "ต้องมีกลุ่ม SCALING (ขูดหินปูน) เสมอ",
  MCP_UNKNOWN_M_TREAT_IDS: "มีรายการหัตถการที่ไม่ใช่ของคลินิกนี้ กรุณาโหลดหน้าใหม่",
  MCP_UNKNOWN_M_TREAT_CATE_IDS: "มีหมวดหัตถการที่ไม่ใช่ของคลินิกนี้ กรุณาโหลดหน้าใหม่",
  MCP_CONNECTION_ID_INVALID: "ไม่พบการเชื่อมต่อนี้",
  MCP_CONNECTION_NOT_FOUND: "ไม่พบการเชื่อมต่อนี้ (อาจถูกยกเลิกไปแล้ว)",
  MCP_AUDIT_RANGE_TOO_LONG: "ช่วงวันที่ยาวเกินไป: ไม่เกิน 31 วัน หรือไม่เกิน 366 วันเมื่อค้นหาด้วย HN หรือรหัสคนไข้",
  MCP_AUDIT_RANGE_INVALID: "วันที่เริ่มต้องไม่เกินวันที่สิ้นสุด",
  MCP_AUDIT_DATE_INVALID: "รูปแบบวันที่ไม่ถูกต้อง",
  MCP_AUDIT_DATE_BUDDHIST_YEAR: "กรุณาใช้ปี ค.ศ. (เช่น 2026)",
  MCP_AUDIT_HN_INVALID: "HN ยาวเกินไป",
  MCP_AUDIT_QUERY_TIMEOUT: "ค้นหานานเกินไป กรุณาลดช่วงวันที่หรือเพิ่มตัวกรอง",
  MCP_AUDIT_UID_INVALID: "ผู้ใช้ที่เลือกไม่ถูกต้อง กรุณาลองใหม่",
  MCP_AUDIT_PATIENT_ID_INVALID: "รหัสคนไข้ไม่ถูกต้อง ต้องเป็นจำนวนเต็มบวก",
  MCP_AUDIT_TOOL_INVALID: "เครื่องมือที่เลือกไม่ถูกต้อง กรุณาลองใหม่",
  MCP_AUDIT_LIMIT_INVALID: "จำนวนรายการต่อหน้าไม่ถูกต้อง กรุณาลองใหม่",
  MCP_AUDIT_OFFSET_INVALID: "ตำแหน่งหน้าที่ขอไม่ถูกต้อง กรุณาลองใหม่",
};

export const mcpErrorMessage = (error, fallback = "เกิดข้อผิดพลาด กรุณาลองใหม่") => {
  const raw = error && error.response && error.response.data ? error.response.data.errorMessage : null;
  const text = typeof raw === "string" ? raw : raw && raw.message;
  if (!text) return fallback;
  const code = text.split(":")[0].trim();
  return MESSAGES[code] || fallback;
};
